<script setup lang="ts">
import { useRoute } from 'vue-router'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip'

const route = useRoute()

const isActive = (name: string, otherActiveRoutes?: string[]) => {
  if (!route.name) return false
  if (route.name === name || route.name.toString().startsWith(name + '-')) return true
  if (otherActiveRoutes) {
    return otherActiveRoutes.some(
      (activeRoute) =>
        route.name === activeRoute || route.name?.toString().startsWith(activeRoute + '-'),
    )
  }
  return false
}

const props = defineProps<{
  to?: string
  otherActiveRoutes?: string[]
  title: string
}>()
</script>

<template>
  <TooltipProvider>
    <Tooltip>
      <TooltipTrigger as-child>
        <RouterLink
          :to="{ name: props.to || 'home' }"
          :class="[
            isActive(props.to || '', props.otherActiveRoutes)
              ? 'bg-sidebar-primary text-primary-foreground'
              : 'md:text-tertiary text-primary hover:text-primary hover:bg-primary-foreground',
          ]"
          :aria-label="props.title"
          class="focus-visible:ring-primary flex w-10 items-center justify-center rounded-lg p-2 transition focus:outline-none focus-visible:ring-2"
        >
          <slot name="icon" />
        </RouterLink>
      </TooltipTrigger>
      <TooltipContent side="right" :sideOffset="8" role="tooltip">
        <p>{{ props.title }}</p>
      </TooltipContent>
    </Tooltip>
  </TooltipProvider>
</template>
